import { Injectable, signal } from '@angular/core'
import { ConfirmedSessionsResponse } from '@app/core/_models'
import { UtilsService } from '@app/core/_services'

@Injectable({
    providedIn: 'root',
})
export class UpcomingSessionsService {
    readonly visible = signal(false)
    constructor(private utilsService: UtilsService) {}

    setMobileUpcomingSessionVisible() {
        this.visible.set(true)
    }
    clearMobileUpcomingSessionVisible() {
        this.visible.set(false)
    }

    public getSessionToDisplay(
        confirmedSessions: ConfirmedSessionsResponse[],
    ): ConfirmedSessionsResponse | null {
        const currentTime = this.utilsService.getCurrentTimestamp()
        // get the index of the earliest session that hasn't ended yet
        let index = confirmedSessions.findIndex((session) => {
            return !this.utilsService.hasSessionEnded(
                session.sessionTime,
                session.duration,
                currentTime,
            )
        })

        if (index === -1) {
            return null
        }

        // if that session is not in a state that should be displayed, check the next one.
        let session = confirmedSessions[index]
        if (
            !this.utilsService.shouldDisplaySession(
                session.sessionType,
                session.sessionTime,
                session.state,
                !!session.partnerId,
            )
        ) {
            index++
            if (confirmedSessions.length >= index + 1) {
                session = confirmedSessions[index]
                if (
                    !session ||
                    !this.utilsService.shouldDisplaySession(
                        session.sessionType,
                        session.sessionTime,
                        session.state,
                        !!session.partnerId,
                    )
                ) {
                    return null
                }
            } else {
                return null
            }
        }

        // we've found a session to display! ayyyy
        return session
    }
}
